// start:ng42.barrel
export * from './authentication.guard';
export * from './authentication.service';
// end:ng42.barrel
